import React from 'react';
import { Badge } from '../common';
import type { MatchTier } from '../../types/match';
import { MATCH_TIER_CONFIG } from '../../types/match';

interface MatchTierBadgeProps {
  tier: MatchTier;
  size?: 'xs' | 'sm' | 'md';
  showIcon?: boolean;
  className?: string;
}

const MatchTierBadge: React.FC<MatchTierBadgeProps> = ({
  tier,
  size = 'sm',
  showIcon = true,
  className = '',
}) => {
  const config = MATCH_TIER_CONFIG[tier];

  if (!config) return null;

  // Jun-18: removed the explainer tooltip that exposed the internal scoring
  // jargon (LLM-judged score, numeric bands like "85+", "reciprocal fit").
  // It confused clients about what they were looking at. The human-readable
  // label (e.g. "Strong Match", "Worth Exploring") stands on its own.
  return (
    <Badge size={size} color={config.color} className={className}>
      {showIcon && <span className="mr-1">{config.icon}</span>}
      {config.label}
    </Badge>
  );
};

export default MatchTierBadge;
